import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';

import LoginHeader from './Login/Login.js';
import AdminView from './Admin/Admin.js';
import AvailableSlotsView from './Home/AvailableSlots.js';
import MyMeetings from './MyMeetings/MyMeetings.js';
import NavBar from './NavBar.js'
import { getAuth } from 'firebase/auth';
import baseUrl from './api.js';

function App() {
    const [user, setCurrentUser] = useState(null);
    const [auth, setAuth] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const authInstance = getAuth();
        setAuth(authInstance);
        const savedUser = localStorage.getItem('user');
        if (savedUser) {
            setCurrentUser(JSON.parse(savedUser));
        }
        setIsLoading(false);
    }, []);

    const checkEmailDomain = (email) => {
        const allowedDomains = ["volunteer.heartfulness.org"];
        const emailDomain = email.split("@")[1];
        return allowedDomains.includes(emailDomain);
    };

    const didTapLogin = (user) => {
        if (user != null) {
            getAbhyasi(user);
        }
    };

    const logOut = () => {
        auth.signOut();
        setCurrentUser(null);
        localStorage.removeItem('user');
    };

    const getAbhyasi = (user) => {
        const url = `${baseUrl}/api/users/me`;
        const headers = new Headers();
        headers.append('X-API-KEY', ",PRGojtX9`c4e24219-fb95-;'.4ed8392hfds';");
        headers.append('uid', user.uid);

        fetch(url, { method: 'GET', headers })
            .then(response => {
                if (response.status === 404) {
                    alert('You are not a registered user. Please contact the admin.');
                    return;
                }
                if (response.status === 401) {
                    alert('You are not authorized user. Please try to sign-up');
                    return;
                }
                return response.json();
            })
            .then(data => {
                const updatedUser = {
                    uid: data.uid,
                    displayName: user.displayName,
                    email: user.email,
                    role: data.role
                };
                setCurrentUser(updatedUser);
                localStorage.setItem('user', JSON.stringify(updatedUser));
            })
            .catch(error => {
                console.error('There was a problem logging in.', error);
            });
    };

    if (isLoading) return <div>Loading...</div>;

    return (
        <BrowserRouter>
            <NavBar user={user} logOut={logOut} />
            <AppRoutes user={user} didTapLogin={didTapLogin} logOut={logOut} />
        </BrowserRouter>
    );
    }

function AppRoutes({ user, didTapLogin, logOut }) {
    return (
        <Routes>
            <Route path="/login" element={user ? <Navigate to="/home" /> : <LoginHeader didTapLogin={didTapLogin} />} />
            <Route path="/home" element={user ? <MyMeetings profile={user} /> : <Navigate to="/login" />} />
            <Route path="/available" element={user ? <AvailableSlotsView profile={user} /> : <Navigate to="/login" />} />
            <Route path="/admin" element={user?.role === 'ADMIN' ? <AdminView profile={user} /> : <Navigate to="/login" />} />
            <Route path="*" element={<Navigate to={user ? "/home" : "/login"} />} />
        </Routes>
    );
}

export default App;
